<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('notification')">Notification</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>
      #{{ form.id }}
    </h1>
    <trashed-message v-if="notification.deleted_at" class="mb-6" @restore="restore">
      This notification has been deleted.
    </trashed-message>
    <preview :preview_message=form.message />
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">

          <textarea-input v-model="form.message" class="pr-6 pb-8 w-full" label="Notification" rows="4" max-rows="6" :error="this.$page.props.errors.message"/>
          <text-input v-model="form.wait_time" class="pr-6 pb-8 lg:w-1/2" label="Wait Time (in minutes)" :error="this.$page.props.errors.wait_time"/>
          <select-input v-model="form.is_enabled" class="pr-6 pb-8 w-full lg:w-1/2" label="Is Enabled">
             <option value="1">Yes</option>
             <option value="0">No</option>
          </select-input>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button v-if="!notification.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Delete Notification</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Update Notification</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import TextareaInput from '../../Shared/TextareaInput.vue'
import Preview from '@/Shared/Preview.vue'

export default {
  metaInfo() {
    return {
      title: `Notification #${this.form.id}`,
    }
  },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    TextareaInput,
    Preview,
  },
  layout: Layout,
  props: {
    notification: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        id: this.notification.id,
        message: this.notification.message,
        wait_time: this.notification.wait_time,
        is_enabled: this.notification.is_enabled == true ? '1' : '0',
      }),
    }
  },
  methods: {
    update() {
      this.form.put(this.route('notification.update', this.notification.id))
    },
    destroy() {
      if (confirm('Are you sure you want to delete this notification?')) {
        this.$inertia.delete(this.route('notification.destroy', this.notification.id))
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this notification?')) {
        this.$inertia.put(this.route('notification.restore', this.notification.id))
      }
    },
  },
}
</script>
